import React, { useState } from "react";

const LeadCaptureForm = () => {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    goal: "Build passive income",
    email: "",
    phone: "",
    name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });

    const res = await fetch("https://formspree.io/f/mwpljdyg", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formPayload,
    });

    if (res.ok) {
      setSubmitted(true);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6 ring-1 ring-gray-200">
      <h2 className="text-xl font-semibold text-[#003366] mb-4">
        Start Your Property Journey
      </h2>
      <p className="text-sm text-gray-600 mb-4">
        Answer a few quick questions and we’ll guide you to the right investment strategy.
      </p>

      {submitted ? (
        <p className="text-green-600 font-semibold">Thank you! We’ll be in touch soon.</p>
      ) : (
        <form onSubmit={handleFinalSubmit}>
          {step === 1 && (
            <>
              <div className="mb-3">
                <label className="block mb-1 text-sm font-medium">What's your investment goal?</label>
                <select
                  name="goal"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={formData.goal}
                  onChange={handleChange}
                >
                  <option>Build passive income</option>
                  <option>Maximize capital growth</option>
                  <option>Buy through SMSF</option>
                  <option>Not sure yet</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="block mb-1 text-sm font-medium">Your Email</label>
                <input
                  type="email"
                  name="email"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="you@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="block mb-1 text-sm font-medium">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="04xx xxx xxx"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="button"
                onClick={() => setStep(2)}
                className="w-full bg-[#da3e13] text-white py-2 rounded-xl font-semibold hover:bg-[#b9320f] transition"
              >
                Next
              </button>
              <input type="hidden" name="formSource" value="Homepage Lead Form" />
              <input type="hidden" name="_subject" value="New Lead - Homepage Form" />


            </>
          )}

          {step === 2 && (
            <>
              <div className="mb-3">
                <label className="block mb-1 text-sm font-medium">Your Name</label>
                <input
                  type="text"
                  name="name"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#da3e13] text-white py-2 rounded-xl font-semibold hover:bg-[#b9320f] transition"
              >
                Get My Free Strategy
              </button>
            </>
          )}
        </form>
      )}
    </div>
  );
};

export default LeadCaptureForm;
